import React,{createContext,useContext,useState,useEffect} from 'react';

const ThemeCtx=createContext(null);
export const useTheme=()=>useContext(ThemeCtx);

export const ThemeProvider=({children})=>{
  const[theme,setTheme]=useState(()=>localStorage.getItem('erp_theme')||'dark');

  useEffect(()=>{
    document.documentElement.setAttribute('data-theme',theme);
    localStorage.setItem('erp_theme',theme);
  },[theme]);

  const toggle=()=>setTheme(t=>t==='dark'?'light':'dark');

  return(
    <ThemeCtx.Provider value={{theme,toggle,isDark:theme==='dark'}}>
      {children}
    </ThemeCtx.Provider>
  );
};
